import { render, staticRenderFns } from "./SearchHeader.container.vue?vue&type=template&id=3b0cf736&scoped=true&"
import script from "./SearchHeader.container.vue?vue&type=script&lang=ts&"
export * from "./SearchHeader.container.vue?vue&type=script&lang=ts&"
import style0 from "./SearchHeader.container.vue?vue&type=style&index=0&id=3b0cf736&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0cf736",
  null
  
)

export default component.exports